import { all, fork } from "redux-saga/effects";

import Alert from "./Alert/saga";

//public
import AuthSaga from "./auth/login/saga";
import Register from "./auth/register/saga";
import File from "./file/saga";
import VerifyEmail from "./auth/verify/saga";
import SendOtp from "./auth/sendOtp/saga";
import JoinUs from "./home/joinUs/saga";
import Currency from "./currency/saga";
import Crypto from "./crypto/saga";
import Settings from "./home/settings/saga";
import Price from "./home/price/saga";
import Wallet from "./wallet/saga";
import Content from "./content/saga";
import UniRamp from "./UniRamp/saga";
import blogs from "./blogs/saga";
import favourite from "./favourite/saga";

export default function* rootSaga() {
  yield all([
    fork(Alert),
    fork(AuthSaga),
    Register(),
    File(),
    VerifyEmail(),
    SendOtp(),
    JoinUs(),
    Currency(),
    Crypto(),
    Settings(),
    Price(),
    Wallet(),
    Content(),
    UniRamp(),
    fork(blogs),
    fork(favourite),

  ]);
}
